import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva("wl-badge-guide", {
  variants: {
    variant: {
      default: "wl-badge-guide-draft",
      secondary: "wl-badge-guide-scheduled",
      destructive: "wl-badge-guide-rejected",
      outline: "wl-badge-guide-border",
      draft: "wl-badge-guide-draft",
      scheduled: "wl-badge-guide-scheduled",
      progress: "wl-badge-guide-progress",
      pending: "wl-badge-guide-pending",
      partially: "wl-badge-guide-partially",
      paid: "wl-badge-guide-paid",
      overpaid: "wl-badge-guide-overpaid",
      closed: "wl-badge-guide-closed",
      overdue: "wl-badge-guide-overdue",
      rejected: "wl-badge-guide-rejected",
      valid: "wl-badge-guide-valid",
    },
    size: {
      default: "",
      sm: "wl-badge-guide-sm",
      lg: "wl-lg",
      xl: "wl-xl",
    },
    shape: {
      default: "",
      rounded: "wl-badge-guide-rounded",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
    shape: "default",
  },
});

function Badge({
  className,
  variant,
  size,
  shape,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span";

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant, size, shape }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
